import { createContext } from "react";

const WebsocketContext = createContext({});

export default WebsocketContext;
